<template>
  <main
    class="main animated fadeIn faster"
    :class="{ 'expand-main': isMenuCollapse }"
  >
    <div v-if="isUrlNotion" class="playbook-embed">
      <iframe
        :src="urlNotion"
        class="playbook-embed__frame"
        title="Playbook"
        allowfullscreen
      />
    </div>
    <div class="row mx-0 w-100" v-else>
      <div class="col-12 playbook-am-shell px-0 px-md-3">
        <contactWithYourAM :clientId="user.client_id" />
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import contactWithYourAM from "@/views/ContactWithYourAM.vue";

export default {
  name: "ClientPlaybook",
  components: { contactWithYourAM },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      user: (state) => state.authentication.user,
    }),
    playbookUrlTrimmed() {
      const u = this.user && this.user.playbook_url;
      if (u == null || typeof u !== "string") return "";
      return u.trim();
    },
    isUrlNotion() {
      const s = this.playbookUrlTrimmed;
      return s.length > 0 && this.isNotionPlaybookUrl(s);
    },
    urlNotion() {
      return this.isUrlNotion ? this.playbookUrlTrimmed : "";
    },
  },
  methods: {
    isNotionPlaybookUrl(urlString) {
      if (urlString == null || typeof urlString !== "string") return false;
      const str = urlString.trim();
      if (!str) return false;
      let url;
      try {
        url = new URL(str);
      } catch {
        return false;
      }
      if (url.protocol !== "https:") return false;
      const host = url.hostname.toLowerCase();
      return host === "notion.so" || host === "www.notion.so" || host.endsWith(".notion.site");
    },
  },
};
</script>

<style scoped>
/*
 * Compensa el px-4 del router-view en Home.vue.
 * El iframe por defecto mide 150px de alto si no tiene height explícita: hay que dar altura al
 * contenedor y height:100% al iframe (min-height sola no siempre rellena el viewport).
 */
.playbook-embed {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  width: calc(100% + 3rem);
  max-width: none;
  /* Reserva ~72px para header/top bar; ajustá si sobra o falta espacio */
  height: calc(100vh - 72px);
  min-height: 560px;
}
.playbook-embed__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Row sin .col hace que el hijo flex encoja al contenido; la tarjeta queda pegada a la izquierda. */
.playbook-am-shell {
  max-width: 100%;
}
</style>

